import React, { useEffect, useState } from 'react';
import { Slide } from 'react-reveal'
import AdmissionCourseAnimations from '../../PowerFullAnimation/AdmissionCourseAnimations';
import AdmissionCourseCart from './AdmissionCourseCart';
import PopularCourseCartAimation from '../../PowerFullAnimation/PopularCourseCartAimation';




const AdmissionCourse = () => {

    const [course, setCourse] = useState([]);
    const [loadding, setLoadding] = useState(true);


    useEffect(() => {
        fetch('https://one0m-backend2.onrender.com/freePaid')
            .then(res => res.json())
            .then(data => {
                setCourse(data?.freePaidData);
                setLoadding(false);
            })
            .catch(err => {
                setLoadding(true)
            })
    }, [course])

    return (
        <div>
            <div className="course-title mb-3">
                <Slide right>
                    <h4 className='fw-bold text-center'>ভর্তি পরীক্ষা প্রোগ্রাম সমূহ</h4>

                </Slide>
            </div>
            <div className="courseData">
                <div className="row">
                    {
                        course?.map(singleCourse => <AdmissionCourseCart singleCourse={singleCourse} key={singleCourse?._id} />)
                    }
                </div>
            </div>
            <div className="setLoadding">
                {
                    loadding ? <>
                        <PopularCourseCartAimation />
                    </>
                        : ''
                }
            </div>
        </div>
    );
};

export default AdmissionCourse;